import { render, staticRenderFns } from "./ChildInfo.vue?vue&type=template&id=6e37e6b2&"
import script from "./ChildInfo.vue?vue&type=script&lang=js&"
export * from "./ChildInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports